import ModulesHelper from '@core/services/modules.helper';
import AuthorizationHelper from '@auth/services/authorization.helper';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class ClubSidebarEntriesMixin extends Vue {
  declare hideMenuItem: boolean;
  declare hideTrueCostSidebar: boolean;
  declare analyticsActivated: boolean;

  public get clubMenuEntriesTabs() {
    return ['main', 'configuration'];
  }

  public get clubMainMenuEntries() {
    return [
      // {
      //   header: true,
      //   title: this.$t('global.sidebar_menu.main_menu.club.dashboard'),
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
      //   icon: 'pe-7s-keypad',
      //   title: this.$t('global.sidebar_menu.main_menu.club.dashboard'),
      //   hidden: this.hideMenuItem,
      //   exactPath: true,
      // },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.club.admin_management'),
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/club-contacts`),
        title: this.$t('global.sidebar_menu.main_menu.club.contacts'),
        icon: 'pe-7s-user',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contacts],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/club-team-and-groups`),
        title: this.$t('global.sidebar_menu.main_menu.club.teams-and-groups'),
        icon: 'pe-7s-users',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contacts],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.club.membership_management'),
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/membership-categories`),
        title: this.$t('global.sidebar_menu.main_menu.club.memberships_catalog'),
        icon: 'pe-7s-bookmarks',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/memberships`),
        title: this.$t('global.sidebar_menu.main_menu.club.memberships_follow_up'),
        icon: 'pe-7s-id',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/documents`),
        title: this.$t('global.sidebar_menu.main_menu.documents'),
        icon: 'pe-7s-albums',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.documents],
        module: ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.club.sports_management'),
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/club-trainings`),
        title: this.$t('global.sidebar_menu.main_menu.club.trainings'),
        icon: 'pe-7s-note2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/club-competitions`),
        title: this.$t('global.sidebar_menu.main_menu.club.competitions'),
        icon: 'pe-7s-medal',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/main/club-courses`),
      //   title: this.$t('global.sidebar_menu.main_menu.club.courses'),
      //   icon: 'pe-7s-ball',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
      //   module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      // },
      // {
      //   header: true,
      //   title: this.$t('global.sidebar_menu.main_menu.club.calendars'),
      //   hidden: this.hideMenuItem,
      // },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/club-activity-calendar`),
        title: this.$t('global.sidebar_menu.main_menu.club.activity-calendar'),
        icon: 'pe-7s-date',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/main/club-resources-calendar`),
      //   title: this.$t('global.sidebar_menu.main_menu.club.resources'),
      //   icon: 'pe-7s-notebook',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.booking_events_calendar],
      //   module: ModulesHelper.BOOKINGS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.club.accounting_management'),
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        permissions: ['sidebar_accounting_section'],
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/main/tickets`),
      //   title: this.$t('global.sidebar_menu.main_menu.club.invoices'),
      //   icon: 'pe-7s-cart',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.tickets],
      //   module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      // },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/club-payments`),
        title: this.$t('global.sidebar_menu.main_menu.payments'),
        icon: 'pe-7s-credit',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.payments],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.club.comunications'),
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.messages],
        module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/club-messages`),
        title: this.$t('global.sidebar_menu.main_menu.club.messages'),
        icon: 'pe-7s-comment',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.messages],
        module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
      },
    ];
  }

  get clubCommunicationMenuEntries() {
    return [
      {
        header: true,
        title: this.$t('global.sidebar_menu.communication_menu.communication'),
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.messages],
        module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/mailbox`),
        title: this.$t('global.sidebar_menu.communication_menu.inbox'),
        icon: 'pe-7s-comment',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.messages],
        module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.communication_menu.website'),
        permissions: ['sidebar_website_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/menu-entries`),
        title: this.$t('global.sidebar_menu.communication_menu.menu'),
        icon: 'pe-7s-network',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.menu_entries],
        module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/post-categories`),
        title: this.$t('global.sidebar_menu.configuration_menu.post_categories'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.post_categories],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/posts`),
        title: this.$t('global.sidebar_menu.communication_menu.posts'),
        icon: 'pe-7s-news-paper',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.posts],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/widgets`),
        title: this.$t('global.sidebar_menu.communication_menu.widgets'),
        icon: 'pe-7s-plugin',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.widgets],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.communication_menu.library'),
        permissions: ['sidebar_library_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/media`),
        title: this.$t('global.sidebar_menu.configuration_menu.media'),
        icon: 'pe-7s-file',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.media],
      },
    ];
  }

  get clubConfigurationMenuEntries() {
    return [
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.basic_configuration'),
        permissions: ['sidebar_basic_configuration_section'],
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/resources`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.resources'),
      //   icon: 'pe-7s-culture',
      //   exactPath: true,
      //   hidden: this.hideMenuItem,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.resources],
      //   module: ModulesHelper.BOOKINGS_MODULE_NAME,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/sectors`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.sectors'),
      //   icon: 'pe-7s-network',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.sectors],
      //   module: ModulesHelper.BOOKINGS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/periods`),
        title: this.$t('global.sidebar_menu.configuration_menu.periods'),
        icon: 'pe-7s-date',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.periods],
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/subscription-categories`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.subscription_categories'),
      //   icon: 'pe-7s-id',
      //   exactPath: true,
      //   hidden: this.hideMenuItem,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscription_categories],
      //   module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      // },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/profiles`),
        title: this.$t('global.sidebar_menu.main_menu.users'),
        icon: 'pe-7s-users',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.profiles],
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.categories_and_tags'),
        modules: [
          ModulesHelper.CONTACTS_MODULE_NAME,
          ModulesHelper.BOOKINGS_MODULE_NAME,
          ModulesHelper.ACTIVITIES_MODULE_NAME,
          ModulesHelper.POS_MODULE_NAME,
        ],
        permissions: ['sidebar_categories_configuration_section'],
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/price-categories`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.price_categories'),
      //   hidden: this.hideMenuItem,
      //   icon: 'pe-7s-folder',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.price_categories],
      //   module: ModulesHelper.CONTACTS_MODULE_NAME,
      // },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/contact-tags`),
        title: this.$t('global.sidebar_menu.configuration_menu.contact_tags'),
        icon: 'pe-7s-ticket',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contact_tags],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/main/activity-categories`),
      //   title: this.$t('global.sidebar_menu.main_menu.activity_categories'),
      //   icon: 'pe-7s-folder',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_categories],
      //   module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/main/certificate-categories`),
      //   title: this.$t('global.sidebar_menu.main_menu.certificate_categories'),
      //   icon: 'pe-7s-folder',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.certificate_categories],
      //   module: ModulesHelper.CERTIFICATES_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/article-tags`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.article_tags'),
      //   icon: 'pe-7s-ticket',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.article_tags],
      //   module: ModulesHelper.POS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.templates_and_processes'),
        permissions: ['sidebar_template_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/templates`),
        title: this.$t('global.sidebar_menu.configuration_menu.templates'),
        icon: 'pe-7s-news-paper',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.templates],
        // permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.options_and_settings'),
        permissions: ['sidebar_options_and_settings_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/club-settings`),
        title: this.$t('global.sidebar_menu.configuration_menu.center_settings'),
        icon: 'pe-7s-edit',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.center_settings],
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.super_admin_options_section'),
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/superadmin-options`),
        title: this.$t('global.sidebar_menu.configuration_menu.superadmin_options'),
        icon: 'pe-7s-door-lock',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
        // hidden: this.hideMenuItem,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/center-settings`),
        title: this.$t('global.sidebar_menu.configuration_menu.center_settings'),
        icon: 'pe-7s-edit',
        exactPath: true,
        // permissions: [AuthorizationHelper.fixedPermissions.sidebar.center_settings],
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/disciplines`),
        title: this.$t('global.sidebar_menu.configuration_menu.disciplines'),
        icon: 'pe-7s-ball',
        exactPath: true,
        // permissions: [AuthorizationHelper.fixedPermissions.sidebar.disciplines],
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/contact-relation-categories`),
        title: this.$t('global.sidebar_menu.configuration_menu.contact_relation_categories'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
        // permissions: [AuthorizationHelper.fixedPermissions.sidebar.contact_relation_categories],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },

      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/option-groups`),
        title: this.$t('global.sidebar_menu.configuration_menu.option_groups'),
        icon: 'pe-7s-config',
        exactPath: true,
        // permissions: [AuthorizationHelper.fixedPermissions.sidebar.option_groups],
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.accounting_configuration'),
        permissions: ['sidebar_accounting_configuration_section'],
        modules: [
          ModulesHelper.TAX_MANAGEMENT_MODULE_NAME,
          ModulesHelper.SUBVENTIONS_MODULE_NAME,
          ModulesHelper.POS_MODULE_NAME,
          ModulesHelper.PAYMENT_TERMINALS_MODULE_NAME,
        ],
        hidden: this.hideMenuItem,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/articles`),
        title: this.$t('global.sidebar_menu.configuration_menu.articles'),
        icon: 'pe-7s-drawer',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.articles],
        module: ModulesHelper.POS_MODULE_NAME,
        hidden: this.hideMenuItem,
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/discounts`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.discounts'),
      //   icon: 'pe-7s-drawer',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.discounts],
      //   module: ModulesHelper.POS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/article-true-costs`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.article-true-costs'),
      //   hidden: this.hideTrueCostSidebar ?? this.hideMenuItem,
      //   icon: 'pe-7s-drawer',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.article_true_costs],
      //   module: ModulesHelper.SUBVENTIONS_MODULE_NAME,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/taxes`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.taxes'),
      //   icon: 'pe-7s-piggy',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.taxes],
      //   module: ModulesHelper.TAX_MANAGEMENT_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/accounting-journals`),
        title: this.$t('global.sidebar_menu.configuration_menu.accounting-journals'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-notebook',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.accounting_journals],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/accounts`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.accounts'),
      //   hidden: this.hideMenuItem,
      //   icon: 'pe-7s-portfolio',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.accounts],
      //   module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/analytic-accounts`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.analytic_accounts'),
      //   hidden: this.hideMenuItem,
      //   icon: 'pe-7s-portfolio',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.analytic_accounts],
      //   module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/pos-boxes`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.pos_boxes'),
      //   icon: 'pe-7s-calculator',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_boxes],
      //   module: ModulesHelper.POS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/terminals`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.terminals'),
      //   icon: 'pe-7s-print',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.terminals],
      //   module: ModulesHelper.PAYMENT_TERMINALS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   header: true,
      //   title: this.$t('global.sidebar_menu.configuration_menu.schedules_configuration'),
      //   module: ModulesHelper.BOOKINGS_MODULE_NAME,
      //   permissions: ['sidebar_schedule_section'],
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/holidays`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.holidays'),
      //   icon: 'pe-7s-date',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.holidays],
      //   module: ModulesHelper.BOOKINGS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/slot-price-categories`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.slot_price_categories'),
      //   icon: 'pe-7s-folder',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.slot_price_categories],
      //   module: ModulesHelper.BOOKINGS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
      // {
      //   href: this.$clientRouter.getClientUrl(`admin/configuration/schedules`),
      //   title: this.$t('global.sidebar_menu.configuration_menu.schedules'),
      //   icon: 'pe-7s-folder',
      //   exactPath: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.schedules],
      //   module: ModulesHelper.BOOKINGS_MODULE_NAME,
      //   hidden: this.hideMenuItem,
      // },
    ];
  }
}
